import { Breadcrumb, Flex, Heading } from '@applyboard/crystal-ui';
import { useProgramDetails } from '../context/ProgramDetailsContext';
import { BreadcrumbItem } from '~/utils';

export function ProgramDetailsHeading() {
  const { program, isLoadingProgram } = useProgramDetails();

  const breadcrumbItems: BreadcrumbItem[] = [
    {
      href: '/program-catalog',
      label: 'Program Catalog',
    },
    {
      href: `/program-catalog/${program?.id}`,
      label: `Program Details - ${program?.code}`,
    },
  ] as BreadcrumbItem[];

  return (
    <Flex direction="column" gap={8}>
      {!isLoadingProgram && <Breadcrumb items={breadcrumbItems} />}
      <Flex justify="between" align="center">
        <Heading contrast="high" level={1} variant="titleL">
          {program?.name}
        </Heading>
        {/* TODO: Enable this when we have a way to edit the program
        <Button intent="primary" emphasis="highlighted" leadIcon={EditOutlineIcon}>
          Edit Program
        </Button> 
        */}
      </Flex>
    </Flex>
  );
}
